import React, { useEffect, useState } from "react";
import useApp from "../../utils/useApp";
import { Button, Col, Container, Row, Spinner } from "react-bootstrap";
import PeopleCard from "./PeopleCard";
import ToastMsg from "../ui/ToastMsg";
import { fetchNoteTypes } from "../../services/httpClient";

interface PeopleViewState {
  filteredAllPeople: any[];
  filteredMyPeople: any[];
  loadingMore: boolean;
  peopleLoaded: number;
  addMorePeople: any;
  limitedAccess: boolean;
}

const PeopleView = ({ filteredAllPeople, filteredMyPeople, loadingMore, peopleLoaded, addMorePeople, limitedAccess }: PeopleViewState) => {
  const { viewAllCases }: any = useApp();
  const [types, setTypes] = useState<any[]>([]);
  const [showToast, setShowToast] = useState<boolean>(false);
  const [toastBody, setToastBody] = useState<string>("");
  const [toastText, setToastText] = useState<string>("");

  useEffect(() => {
    getTypes();
  }, []);

  const getTypes = () => {
    fetchNoteTypes()
      .then((res: any) => {
        var types = res[0].data.filter((n: any) => n?.type !== "system");
        types = types.filter((t: any) => t?.is_published === 1);
        types = types.filter((n: any) => n?.is_archived !== 1);

        var sorted = [...types];
        sorted.sort((a: any, b: any) => a.is_archived - b.is_archived);

        setTypes(sorted);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return (
    <>
      <ToastMsg showToast={showToast} setShowToast={setShowToast} toastText={toastText} toastBody={toastBody} />
      {viewAllCases ? (
        <Row className="justify-content-center mb-5">
          <Container className="card-container">
            {filteredAllPeople.slice(0, peopleLoaded).map((p: any, index) => (
              <PeopleCard
                key={index}
                person={p}
                types={types}
                setShowToast={setShowToast}
                setToastText={setToastText}
                setToastBody={setToastBody}
                limitedAccess={limitedAccess}
              />
            ))}
            {filteredAllPeople.length === 0 && <p className="mt-2">No Person Records</p>}
          </Container>
        </Row>
      ) : (
        <Row className="justify-content-center mb-5">
          <Container className="card-container">
            {filteredMyPeople.map((p: any, index) => (
              <PeopleCard
                key={index}
                person={p}
                types={types}
                setShowToast={setShowToast}
                setToastText={setToastText}
                setToastBody={setToastBody}
                limitedAccess={limitedAccess}
              />
            ))}
            {filteredMyPeople.length === 0 && <p className="mt-2">No Person Records</p>}
          </Container>
        </Row>
      )}
      {loadingMore ? (
        <Button size="sm" className="spinner-button spinner-button-main">
          <Spinner animation="border" style={{ color: "#F6893D" }} />
        </Button>
      ) : (
        // Show "Load More" button if there are more people to load
        // IE: Viewing all cases, and total loaded is less than total people
        viewAllCases &&
        peopleLoaded < filteredAllPeople.length && (
          <Row className="justify-content-center">
            <Col xs="auto">
              <Button className="app-primary-color button mb-5" onClick={() => addMorePeople()}>
                Load More
              </Button>
            </Col>
          </Row>
        )
      )}
      <Row className="mb-5"></Row>
    </>
  );
};

export default PeopleView;
